const cities = {
  basel: 'Basel',
  miamibeach: 'Miami Beach',
  'miami-beach': 'Miami Beach',
  hongkong: 'Hong Kong',
  'hong-kong': 'Hong Kong',
  cities: 'Abu Dhabi',
  general: 'General',
  paris: 'Paris'
}

export default cities
